import { generateElementId } from 'bundles/author-common/utils/IdUtils';
import type { Collection, LearningPath } from 'bundles/enterprise-admin-collection-discovery/types';

export const createDynamicCollection = ({ title, id: referenceId, items }: Collection) => {
  const id = generateElementId();
  return {
    curriculumItems: items.map((_) => ({
      typeName: (
        {
          COURSE: 'courseId',
          SPECIALIZATION: 's12nId',
        } as const
      )[_.canonicalType],
      definition: {
        id: _.id,
      },
    })),
    allCurriculumItemIds: items.map((_) => _.id),
    id,
    title,
    description: {
      typeName: 'cml' as const,
      definition: {
        value: '<co-content><text></text></co-content>',
        dtdId: 'collection/1',
      },
    },
    referenceCollectionConfiguration: {
      referenceCollectionId: {
        typeName: 'presetCollectionId' as const,
        definition: {
          id: referenceId,
        },
      },
      enableSync: true,
    },
  };
};

export const createDynamicLearningPath = ({ title, presetCollectionId, id, items }: LearningPath) => {
  return {
    curriculumItems: items.map((_) => ({
      typeName: (
        {
          COURSE: 'courseId',
        } as const
      )[_.canonicalType],
      definition: {
        id: _.id,
      },
    })),
    allCurriculumItemIds: items.map((_) => _.id),
    id,
    title,
    description: {
      typeName: 'cml' as const,
      definition: {
        value: '<co-content><text></text></co-content>',
        dtdId: 'description/1',
      },
    },
    referenceCollectionConfiguration: {
      referenceCollectionId: {
        typeName: 'presetCollectionId' as const,
        definition: {
          id: presetCollectionId,
        },
      },
      enableSync: false,
    },
  };
};

export const stripCmlTags = (cml: string) => {
  return cml.replace(/<\/?[^>]+(>|$)/g, '');
};
